import {
	Box,
	Button,
	Typography,
	Modal,
	Paper,
	Dialog,
	Divider,
	DialogContent,
	DialogTitle,
	DialogActions,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "../../services/features/dialogSlice/dialogSlice";
import { RootState } from "../../store";

/**
 * ConfirmModal component displays a confirmation dialog.
 *
 * @param {Object} props - Component props.
 * @param {Function} props.handleExit - Function to handle the modal close event confirming exit.
 */
const ConfirmModal = ({ handleExit }: { handleExit: () => void }) => {
	const dispatch = useDispatch();

	const openState = useSelector((state: RootState) => state.dialogSlice.open);
	const open = openState["confirm"];

	const handleClose = () => {
		dispatch(closeDialog("confirm"));
	};

	return (
		<Dialog onClose={handleClose} open={open} className="modalConfirmation_container">
			<DialogTitle>Are you sure you wish to exit?</DialogTitle>
			<DialogContent>
				<Divider />
				<Box pt="1em">
					<Typography variant="cardSubtitle1">You may have unsaved changes.</Typography>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button variant="text" onClick={handleClose}>
					Cancel
				</Button>
				<Button variant="contained" onClick={handleExit}>
					Confirm Exit
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmModal;
